import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError, map, Observable, of, startWith, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
interface APIState<T> {
  loading: boolean,
  error: string | null,
  data: T | null,
}

@Injectable({
  providedIn: 'root',
})
export class Seller {
  private http = inject(HttpClient);


  getOrderList(
    rowNum: any,
    size: any,
    orderStatus: any,
    sortKey: any,
    sortOrder: any
  ): Observable<APIState<any>> {
    return this.http
      .get<any>(
        `${environment.apiUrl}/order/list?rowNum=${rowNum}&size=${size}&orderStatus=${orderStatus}&sortKey=${sortKey}&sortOrder=${sortOrder}`
      )
      .pipe(
        map((response) => ({
          data: response,
          loading: false,
          error: null
        })),
        catchError((error: HttpErrorResponse) =>
          of({
            data: null,
            loading: false,
            error: error.error?.message || error.message || "Unknown Error"
          })
        ),
        startWith({
          data: null,
          loading: true,
          error: null
        })
      );
  }

  searchArticle(rowNum: number, size: number, searchText: string) {
    return this.http.get<any>(`${environment.apiUrl}/catalog/article?rowNum=${rowNum}&size=${size}`)
      .pipe(catchError(this.errorHandle));
  }

  getSellerCatalog(sellerId: any, rowNum: number, size: number, status: any, searchKey: any, searchText: any, topPick: any, availability: any) {
    return this.http.get<any>(`${environment.apiUrl}/catalog/seller/${sellerId}/article?rowNum=${rowNum}&size=${size}&status=${status}&searchKey=${searchKey}&searchText=${searchText}&topPick=${topPick}&availability=${availability}`)
      .pipe(catchError(this.errorHandle));
  }

  postArticleSellerCatalog(sellerId: any, postForm: any) {
    return this.http.post<any>(`${environment.apiUrl}/catalog/seller/${sellerId}/article`, postForm)
      .pipe(catchError(this.errorHandle));
  }

  updateSellerCatalog(sellerId: any, updateArticleFormData: any) {
    return this.http.patch<any>(`${environment.apiUrl}/catalog/seller/${sellerId}/article`, updateArticleFormData)
      .pipe(catchError(this.errorHandle));
  }

  addArticle(addForm: any) {
    return this.http.post<any>(`${environment.apiUrl}/catalog/article`, addForm)
      .pipe(catchError(this.errorHandle));
  }

  updateShipmentStatus(formData: any, orderId: any) {
    return this.http.post<any>(`${environment.apiUrl}/order/${orderId}/audit`, formData)
      .pipe(catchError(this.errorHandle));
  }

  updateOrder(formData: any, orderId: any) {
    return this.http.patch<any>(`${environment.apiUrl}/order/${orderId}`, formData)
      .pipe(catchError(this.errorHandle));
  }







  errorHandle(error: any) {
    let errorMessage = "";
    if (error.error.error instanceof ErrorEvent) {
      errorMessage = error.error.error;
    } else {
      errorMessage = error.error;
    }

    return throwError(() => {
      return errorMessage;
    });
  }
}
